module.exports = __webpack_public_path__ + "img/benefit-05-iot-7.01edeed8.png";